// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

// Each card is a big, tappable shortcut into the site—kids and parents should
// never have to hunt through the nav bar to find the thing they came for.
const shortcuts = [
  {
    to: '/activities',
    title: '🏃‍♂️ Saturday Parkruns',
    text: "Join us every Saturday at 9am at Fletcher's Cove for free, fun, family-friendly 5K runs! Perfect way to start your weekend! 🌟",
    cta: 'Learn More →'
  },
  {
    to: '/racing',
    title: '🏁 Weekend Races',
    text: 'Optional races throughout the DMV - open to all levels with zero pressure to compete. Just pure fun and personal bests! 🎉',
    cta: 'See Calendar →'
  },
  {
    to: '/training-log',
    title: '📊 Training Log',
    text: 'Log your runs, races, and workouts—then watch your progress add up week after week! 🚀',
    cta: 'Start Logging →'
  },
  {
    to: '/about',
    title: '👥 Supportive Community',
    text: 'Where kids can build lasting friendships and grow as runners together! 🤝',
    cta: 'Join Us →'
  }
];

function Home() {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <img 
            src={logo} 
            alt="DC Hawks Logo" 
            style={{ 
              width: '180px', 
              height: '180px', 
              objectFit: 'contain',
              marginBottom: '2rem'
            }}
          />
          <h1 style={{ margin: 0, marginBottom: '1rem' }}>Welcome to<br/>DC Hawks Track Club!</h1>
          <p style={{ margin: 0, maxWidth: '600px' }}>
            An inclusive, low-key running group based in northwest Washington, DC, giving young track athletes more opportunities 
            beyond the school season through weekend runs, races, and training support!
          </p>
        </div>
      </section>

      {/* Quick Highlights */}
      <div className="highlights">
        {shortcuts.map(({ to, title, text, cta }) => (
          <Link key={to} to={to} className="highlight-card highlight-card-link">
            <h3>{title}</h3>
            <p>{text}</p>
            <small className="highlight-card-cta">{cta}</small>
          </Link>
        ))}
      </div>

      {/* Call to Action */}
      <div className="cta-section">
        <h2>Ready to Join the Hawks? 🦅</h2>
        {/*
        <p>
           I'm happy to jump on a quick call to answer 
          any questions, or I can add you directly to our WhatsApp group where all the fun happens!
        </p>
        */}
        <a href="mailto:dario.caldara@gmail.com" className="cta-button">
          Contact Coach Dario 📧
        </a>
      </div>
    </div>
  );
}

export default Home;